export default __webpack_public_path__ + "static/media/OfficeDeskStuffBackground.25f66b3e.svg";